
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1sxt8_1nfva_181",
  "header": "awsui_header_1sxt8_1nfva_214",
  "with-toolbar": "awsui_with-toolbar_1sxt8_1nfva_229",
  "content": "awsui_content_1sxt8_1nfva_247",
  "test-utils-drawer-content": "awsui_test-utils-drawer-content_1sxt8_1nfva_253"
};
  